import { Component } from '@angular/core';
import { DialogRef } from '@icc/ui';

@Component({
    selector: 'icc-complaint-partial-match-confirm-dialog',
    templateUrl: './complaint-partial-match-confirm-dialog.component.html',
    styleUrls: ['./complaint-partial-match-confirm-dialog.component.scss'],
})
export class ComplaintPartialMatchConfirmDialogComponent {

    constructor(private dialogRef: DialogRef) {}

    close(): void {
        this.dialogRef.close(false);
    }

    confirm(): void {
        this.dialogRef.close(true);
    }
}
